import { render, staticRenderFns } from "./field-list.vue?vue&type=template&id=db8a0c06&scoped=true"
import script from "./field-list.vue?vue&type=script&lang=js"
export * from "./field-list.vue?vue&type=script&lang=js"
import style0 from "./field-list.vue?vue&type=style&index=0&id=db8a0c06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8a0c06",
  null
  
)

export default component.exports